export default function (min, max){
  return Math.floor(Math.random() * (max - min + 1) + min)
}



// WEBPACK FOOTER //
// ./node_modules/vux/src/tools/number/random.js